import { useSelector } from "react-redux";

import { Print } from "@mui/icons-material";
import { IconButton, Box } from "@mui/material";
import { Button } from "@mui/material";

import { Tooltip } from "components/Tooltip";
import { CloseX } from "components/utility/CloseX";
import { ModalTitle } from "components/utility/ModalTitle";

import { i18n } from "services/i18nService";
import { isValid as isValidUpsShipment } from "services/sosInventoryService/upsShipment/isValid";
import { checkForUnexpectedProps } from "services/utility/misc";

import { OBJECT_TYPES } from "appConstants";

const OBJECT_TYPE = OBJECT_TYPES.UPS_SHIPMENT.fullString;

const SAVE_ACTION_WIDTH_SMALL = "240px";

const iconButtonSx = {
  padding: "0.4rem",
  height: "36px",
  border: "1px solid",
  borderColor: "lineSeparatorMinor",
  backgroundColor: "white",
  borderRadius: 1,
};

export function UpsShipmentHeader(props) {
  const {
    record,
    handleClose,
    setErrors,
    text,
    openConfirmDialog,
    ...unexpected
  } = props;
  checkForUnexpectedProps("UpsShipmentHeader", unexpected);

  const isLoading = useSelector((state) => state.loading.editModal);

  async function next() {
    // if the record is not in a valid state...
    const isValidErrors = isValidUpsShipment(record);
    if (isValidErrors.messages.length) {
      setErrors(isValidErrors);
      return;
    }
    openConfirmDialog();
  }

  return (
    <>
      <Box
        sx={{
          backgroundColor: "dialogTitleBackground",
          borderBottom: "1px solid",
          borderBottomColor: "lineSeparatorMinor",
          padding: "0.5rem 1rem",
          fontSize: "1.2rem",
        }}
      >
        <div
          style={{
            display: "grid",
            alignItems: "top",
            gridTemplateColumns: `1fr ${SAVE_ACTION_WIDTH_SMALL}`,
          }}
        >
          <div style={{ display: "flex", alignItems: "top" }}>
            <CloseX onClick={handleClose} dataTesting="exitEdit" />
            <ModalTitle
              label={i18n(`objectType.${OBJECT_TYPE}.Sentence`)}
              text={text}
            />
          </div>

          <Box sx={{ displayPrint: "none" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Tooltip placement="bottom-start" title={i18n("global.Print")}>
                <IconButton
                  onClick={() => window.print()}
                  sx={iconButtonSx}
                  size="large"
                >
                  <Print />
                </IconButton>
              </Tooltip>

              <Box sx={{ width: "7em" }}>
                <Tooltip>
                  <span>
                    <Button
                      variant="contained"
                      onClick={next}
                      data-testing="saveAndClose"
                      disableElevation
                      fullWidth
                      disabled={isLoading}
                    >
                      {i18n("saveActions.Next")}
                    </Button>
                  </span>
                </Tooltip>
              </Box>
            </Box>
          </Box>
        </div>
      </Box>
    </>
  );
}
